import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(Item(), {
    state() {
        return {
            id: null,
            title: null,
            questions_per_page: null,
            calculator_enabled: true,
            question_count: null,
            random_question_order: null,
            must_answer_in_order: null,
            original_version_id: null,
            version_number: null,
            points_possible: null,
            locked_for_editing: false,
            quiz_attempt_count: null,
            latest_quiz_attempt: null,

            created_at: null,
            updated_at: null,

            // Relationships
            activities: null,
            activityTemplates: null,
            questions: null,
            tags: [],
            groups: [],
            course_codes: [],
            attempts_count: null,

            order: null,

            type: null,
            quiz_version_id: null,
            quiz_version_number: null,
            has_quiz_attempt: null,
            archived_at: null,
        };
    },

    getters: {
        /**
         * Provide the payload to get from.
         * @param state
         * @param getters
         * @returns {function(*): boolean}
         */
        getWithPayload(state, getters) {
            return (getter, payload = {}) => getters[getter](payload);
        },
    },

    actions: {},

    mutations: {
        SET: (state, { field, value }) => {
            state[field] = value;
        },
    },
});
